import { useState, useContext } from "react";
import {
  Box,
  Grid,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  Typography,
  TableContainer,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import ApiIcon from "@mui/icons-material/Api";
import moment from "moment";
//Srcs
import "../../../Style/pagestyle.scss";
import EmptyData from "../../../Components/Include/EmptyData/EmptyData";
import InvoiceForm from "../../../Components/Invoice/Form/InvoiceForm";
import LoadingPage from "../../../Utils/LoadingPage";
import InvoiceAction from "../../../Components/Invoice/InvoiceAction";
import FooterPagination from "../../../Utils/FooterPagination";
import useWithDimension from "../../../Hooks/useWithDimension";
import useGetInvoiceByStuPagination from "../../../Hooks/useGetInvoiceByStuPagination";
import { AuthContext } from "../../../Context/AuthContext";
// import { SelectDatePicker } from "../../../Components/Include/SelectDatePicker/SelectDatePicker";
import { SearchTextField, ButtonCreate } from "../../../Utils/Component";
import { SelectEnrollmentByStudent } from "../../../Components/Include/DynamicSelect/DynamicSelect";
import {
  currencyFormat,
  generateInvoiceNumber,
} from "../../../Function/DynamicFn";

export default function PaymentForStudent({ studentId }) {
  // Change Language
  const { t } = useContext(AuthContext);

  // Filters state
  // const [toDate, setToDate] = useState(moment());
  const [paymentStatus, setPaymentStatus] = useState("All");
  // const [fromDate, setFromDate] = useState(moment().startOf("month"));
  const [enrollmentId, setEnrollmentId] = useState({ id: "", title: "" });

  const {
    page,
    limit,
    setPage,
    refetch,
    loading,
    tableData,
    setLoading,
    handleLimit,
    handleSearch,
    paginationData,
  } = useGetInvoiceByStuPagination({
    keyword: "",
    // endDate: moment(toDate).format("YYYY-MM-DD"),
    // startDate: moment(fromDate).format("YYYY-MM-DD"),
    endDate: "",
    startDate: "",
    paymentStatus, // All Paid Owe
    studentId: studentId,
    enrollmentId: enrollmentId?.id,
  });

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const translatePaymentStatus = (status) => {
    if (status === "Paid") return t("thead_paid");
    if (status === "Unpaid") return t("thead_unpaid");
    if (status === "Owe") return t("thead_owe");
    else return status;
  };

  // ======================= Resize width Screen ======================
  const { width } = useWithDimension();

  // console.log("tableData :", tableData);

  return (
    <div className="page-container">
      <Box>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={4} md={3} lg={2.4} xl={2}>
            <Typography className={t("class-name-text-field-title")}>
              {t("search")}
            </Typography>
            <SearchTextField
              placeholder={t("thead_invoice_id")}
              className={"text-field"}
              handleSearch={handleSearch}
            />
          </Grid>

          <Grid item xs={6} sm={4} md={3} lg={2.4} xl={2}>
            <Typography className={t("class-name-text-field-title")}>
              {t("thead_class")}
            </Typography>
            <SelectEnrollmentByStudent
              studentId={studentId?.id}
              value={enrollmentId}
              onChange={setEnrollmentId}
              className={"text-field"}
            />
          </Grid>

          {/* Payment status */}
          <Grid item xs={6} sm={4} md={3} lg={2.4} xl={2}>
            <Typography className={t("class-name-text-field-title")}>
              {t("thead_payment_status")}
            </Typography>
            <FormControl fullWidth size="small" className={"text-field"}>
              <Select
                value={paymentStatus}
                onChange={(e) => setPaymentStatus(e?.target?.value)}
              >
                <MenuItem value={"All"}>All</MenuItem>
                <MenuItem value={"Paid"}>Paid</MenuItem>
                <MenuItem value={"Owe"}>Owe</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {/* <Grid item xs={6} sm={4} md={3} lg={2} xl={1.8}>
            <Typography className={t("class-name-text-field-title")}>
              {t("thead_start_date")}
            </Typography>
            <SelectDatePicker value={fromDate} onChange={setFromDate} />
          </Grid>

          <Grid item xs={6} sm={4} md={3} lg={2} xl={1.8}>
            <Typography className={t("class-name-text-field-title")}>
              {t("thead_end_date")}
            </Typography>
            <SelectDatePicker value={toDate} onChange={setToDate} />
          </Grid> */}

          <Grid item xs={12} sm={4} md={6} lg={4.8} xl={6}>
            <ButtonCreate
              handleOpen={handleOpen}
              classBtn={"btn-create"}
              classIcon={"icon-add"}
            />

            {open && (
              <InvoiceForm
                open={open}
                studentId={studentId}
                setRefetch={refetch}
                handleClose={handleClose}
                dialogTitle={"Create"}
              />
            )}
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableRow>
                <TableCell
                  className={t("class-name-header-title-start")}
                  width="5%"
                >
                  {t("no")}
                </TableCell>

                <TableCell className={t("class-name-header-title")} width="10%">
                  {t("thead_invoice_id")}
                </TableCell>

                <TableCell className={t("class-name-header-title")}>
                  {t("thead_date")}
                </TableCell>

                <TableCell className={t("class-name-header-title")}>
                  {t("thead_status")}
                </TableCell>

                <TableCell
                  className={t("class-name-header-title")}
                  align="right"
                >
                  {t("thead_owe_amount")}
                </TableCell>

                <TableCell
                  className={t("class-name-header-title")}
                  align="right"
                >
                  {t("thead_total_amount")}
                </TableCell>

                <TableCell
                  className={t("class-name-header-title-end")}
                ></TableCell>
              </TableRow>
            </TableHead>
            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell
                    colSpan={10}
                    className="body-cell"
                    sx={{ bgcolor: "#fff" }}
                  >
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 || tableData?.length === undefined ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={10} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <>
                    <TableBody className="body">
                      {tableData?.map((row, index) => {
                        // console.log("row::", row);
                        return (
                          <TableRow className="body-row" key={index}>
                            <TableCell
                              className={
                                row?.void
                                  ? "body-cell-start-complete"
                                  : "body-cell-start"
                              }
                            >
                              {index + paginationData?.slNo}
                            </TableCell>
                            <TableCell
                              className={
                                row?.void ? "body-cell-complete" : "body-cell"
                              }
                              sx={{ color: "#131870 !important" }}
                            >
                              {generateInvoiceNumber(
                                row?.invoiceNumber,
                                row?.createdAt,
                              )}
                            </TableCell>

                            <TableCell
                              className={
                                row?.void ? "body-cell-complete" : "body-cell"
                              }
                            >
                              {row?.date &&
                                moment(row?.date).format("DD-MMM-YYYY")}
                            </TableCell>

                            <TableCell
                              className={
                                row?.void ? "body-cell-complete" : "body-cell"
                              }
                            >
                              <Typography className={row?.paymentStatus}>
                                <ApiIcon
                                  sx={{
                                    paddingTop: "2px",
                                    marginRight: 0.7,
                                    fontSize: 14,
                                  }}
                                />
                                {translatePaymentStatus(row?.paymentStatus)}
                              </Typography>
                            </TableCell>

                            <TableCell
                              align="right"
                              className={
                                row?.void ? "body-cell-complete" : "body-cell"
                              }
                              sx={{ color: "red" }}
                            >
                              {`${currencyFormat(row?.totalOwe)} $`}
                            </TableCell>

                            <TableCell
                              className={
                                row?.void ? "body-cell-complete" : "body-cell"
                              }
                              align="right"
                              sx={{ color: "#131870" }}
                            >
                              {currencyFormat(row?.totalAmount || 0)} $
                            </TableCell>

                            <TableCell
                              className={
                                row?.void
                                  ? "body-cell-end-complete"
                                  : "body-cell-end"
                              }
                              align="right"
                            >
                              <InvoiceAction
                                editData={row}
                                setRefetch={refetch}
                                studentId={studentId}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </>
                )}
              </>
            )}
          </Table>
        </TableContainer>

        {/* ====================ឲឲឲឲឲឲឲឲឲឲឲ Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          setLoading={setLoading}
        />
      </Box>
    </div>
  );
}
